module.exports = __webpack_public_path__ + "img/sign.4f78a816.png";